import React from 'react';

const FormDiv = (props) => {
    return ( 
        <div className='FormDiv'>
            <label className='RFormLabel'>{props.label}</label>
            <input 
                className='RFormInput' 
                type={props.type} 
                placeholder={props.placeholder} 
                onChange={(e) => props.onChange(e.target.value)} 
            />
        </div>
     );
}
 
export default FormDiv;